import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { LatestNewsTrendsTitle } from '../../../../../Utils/Constants'
import { H4, LI, P, UL } from '../../../../../AbstractElements'
import { Link } from 'react-router-dom'
import { latestNewsData } from '../../../../../Data/Miscellaneous/Blog'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'

export default function LatestNews() {
    return (
        <Col sm={12}>
            <Card>
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={LatestNewsTrendsTitle} />
                <CardBody>
                    <Row className="gy-3">
                        {latestNewsData.map((item) => (
                            <Col xxl={6} xl={12} md={6} key={item.id}>
                                <div className="blog-card">
                                    <H4>{item.title}</H4>
                                    <P>{item.paragraph}</P>
                                    <div className="post-social">
                                        <UL className="d-flex align-items-center simple-list flex-row">
                                            <LI className="bg-light-primary txt-primary">{item.date}</LI>
                                            <LI className="bg-light-secondary txt-secondary"><i className="fa fa-user mx-1"></i>Admin</LI>
                                            <LI className="bg-light-success txt-success"><i className="fa fa-comments mx-1"></i>{item.comment} Comments</LI>
                                        </UL>
                                    </div>
                                    <Link className="btn" to={`${process.env.PUBLIC_URL}/miscellaneous/blog/blog-detail`}>View more<i className="fa fa-long-arrow-right" /></Link>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </CardBody>
            </Card>
        </Col>
    )
}